function u(f) {
  var s = [],
    h = f.length;
  if (h === 0) return s;
  var l = 0,
    e = "",
    i = "",
    r = !1;
  for (f.charCodeAt(0) === 46 && (s.push(""), l++); l < h;) {
    var t = f[l];
    i ? t === "\\" && l + 1 < h ? (l++, e += f[l]) : t === i ? i = "" : e += t : r ? t === '"' || t === "'" ? i = t : t === "]" ? (r = !1, s.push(e), e = "") : e += t : t === "[" ? (r = !0, e && (s.push(e), e = "")) : t === "." ? e && (s.push(e), e = "") : e += t, l++;
  }
  return e && s.push(e), s;
}
export { u as toPath };